import { jsonToCsv } from "pages/Xero/Reports/ExportButton";
import { NotificationManager } from "react-notifications";

export const exportToCSV = ({ data, filename }) => {
    if (!data || data.length === 0) {
      NotificationManager.error("Data is undefined or empty.");
      return;
    }
  
    const headers = Object.keys(data[0]);
    const rows = data.map(item => Object.values(item));
  
    const result = [headers, ...rows];
  
    jsonToCsv(result, filename);
  };

// quick export from json(api) to excel format (csv) by utilizing jsonToCsv
//
// example usage in your component: 
//  onClick={() => exportToCSV({ data: data, filename: "filename" })}